import api from "@/app/api";
import { AddPage } from "@/app/components/AddPage";
import Private from "@/app/components/Private";
import { ApiContext } from "@/app/contexts/ApiContext";

export default function Page() {
  return (
    <ApiContext.Provider
      value={{
        listData: api.getSponsorships,
        getFieldOptions: api.getSponsorshipFieldOptions,
        getData: api.getSponsorship,
        getFields: api.getSponsorshipFields,
        updateEntry: api.updateSponsorship,
        deleteEntry: api.deleteSponsorship,
        createEntry: api.createSponsorship,
        createFieldOption: api.createSponsorshipFieldOption,
      }}
    >
      <Private>
        <AddPage />
      </Private>
    </ApiContext.Provider>
  );
}
